import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { DiffItem } from '../../coaching-base/diff-decorator';
import { NoteDiffContext } from '../../coaching-base/diff-decorator/note-diff-context.model';
import { EntityType, NoteCategory } from '../../coaching-base/general';
import { TranslationKeyMap } from '../coaching-commitment.i18n';
import { GoalDiffContextView } from '../commitment/goal-diff-context-view.model';

// TODO revise iWill/iWillKnow for custom default commitment notes
function noteLabel(context: NoteDiffContext): string {
    switch (context.noteCategoryId) {
        case NoteCategory.I_WILL:
            return TranslationKeyMap._9508_I_WILL;
        case NoteCategory.I_WILL_KNOW:
            return TranslationKeyMap._9509_I_WILL_KNOW_THAT_I_AM_SUCCESSFUL_WHEN;
        default:
            return TranslationKeyMap._9510_GENERAL_NOTES;
    }
}

@Pipe({
    name: 'cmpsDiffItemElementLabel',
})
export class CmpsDiffItemElementLabelPipe implements PipeTransform {
    constructor(private readonly _translateService: TranslateService) {}

    transform(value: DiffItem): string {
        switch (value.entityTypeId) {
            case EntityType.Note:
                return this._translateService.instant(noteLabel(value.context));
            case EntityType.CoachingEvent:
                return this._translateService.instant(
                    TranslationKeyMap._9548_OBSERVATION,
                );
            case EntityType.Goal:
                // eslint-disable-next-line no-case-declarations
                const ctx = (value.context || {}) as GoalDiffContextView;
                return ctx.metricName;
        }
    }
}
